import styled, { css } from "styled-components"
import Link from "./TransitionLink"
import { basicLinkStyles } from "./TxlLink"

export const topBarButtonStyles = css`
  ${basicLinkStyles}
  float: left;
  height: ${props => props.theme.topBar.height};
  border-radius: calc(${props => props.theme.topBar.height} / 2);
  line-height: 36px;
  background-color: ${props => props.theme.color.translucid};
  opacity: 0.9;
  padding: 5px 20px;
  min-width: ${props => props.theme.topBar.minWidth};
  text-align: center;
  white-space: nowrap;
`

export const TopBarButton = styled(Link)`
  ${topBarButtonStyles}
`

export const SimpleTopBarButton = styled.a`
  ${topBarButtonStyles}
`
